import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
`;

const InfoFooter = () => {
    const { t } = useTranslation('translation');

    return (
        <StyledContainer>
            <span>{t('medical_report_result_explanation')}</span>
            <span>{t('medical_report_copy_explanation')}</span>
        </StyledContainer>
    );
};

export default InfoFooter;
